import { createSlice } from "@reduxjs/toolkit";
import appointmentDetailsbyPatientId from "@custom/rtk-apis/appointment/getAppointmentByPatientId";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const appointmentDetailbyPatientIdSlice = createSlice({
  name: "appointmentDetailbyPatientIdSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(appointmentDetailsbyPatientId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(appointmentDetailsbyPatientId.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(appointmentDetailsbyPatientId.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default appointmentDetailbyPatientIdSlice.reducer;
